exports.getRoundedNumber = (number, precisionAmount) => {
  return +(
    Math.round(number + `e+${precisionAmount}`) + `e-${precisionAmount}`
  );
};
